/** @format */
import { css } from 'styled-components';

const RAINBOW_CIRCLES_ALPHA = '0.2';

const GRADIENT_ANGLE = '82deg';

const BORDER_INSET = 'var(--layout-spacing-4)';

const BORDER_WIDTH = '1px';

const HOLOGRAPHIC_GRADIENT = `
    linear-gradient(
        ${GRADIENT_ANGLE},
        #dbcee8 6.85%,
        #f9e8ff 11.5%,
        #fbeaff 15.69%,
        #f4f4ec 20.39%,
        #f4fcfd 25.46%,
        #add0fc 33.3%,
        #f4fcfd 40.98%,
        #ffffff 49.05%,
        #f5f7fe 60.98%,
        #e4eafd 69.53%,
        #dbe3ff 72.94%,
        #e7dbff 77.04%,
        #f5dbff 80.73%,
        #e6d2eb 84.41%,
        #f3f3eb 88.56%,
        #d0e9e3 92.11%,
        #add0fc 95.55%
    )
`;

const RAINBOW_CIRCLES = `
    radial-gradient(
        circle at 20% 30%,
        rgba(255, 0, 0, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 30%
    ),
    radial-gradient(
        circle at 70% 90%,
        rgba(0, 0, 255, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 40%
    ),
    radial-gradient(
        circle at 30% 80%,
        rgba(255, 255, 0, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 30%
    ),
    radial-gradient(
        circle at 50% 20%,
        rgba(0, 255, 0, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 40%
    ),
    radial-gradient(
        circle at 80% 10%,
        rgba(0, 255, 255, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 30%
    ),
    radial-gradient(
        circle at 0% 90%,
        rgba(255, 255, 0, ${RAINBOW_CIRCLES_ALPHA}),
        transparent 20%
    )
`;

const WHITE_CORNERS = `
    linear-gradient(
        ${GRADIENT_ANGLE}, white 0%, transparent 50%, white 100%
    )
`;

const WHITE_CENTER = `
    radial-gradient(
        circle at 50% 50%, white 35%, transparent 90%
    )
`;

export const styles = css`
    position: relative;
    display: flex;

    .background-container {
        border-radius: var(--holographic-background__border-radius, 0px);
        overflow: hidden;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
        background-blend-mode: soft-light;
        background: ${HOLOGRAPHIC_GRADIENT}, ${RAINBOW_CIRCLES},
            ${WHITE_CORNERS}, ${WHITE_CENTER};

        &:before {
            content: '';
            position: absolute;
            top: ${BORDER_INSET};
            left: ${BORDER_INSET};
            right: ${BORDER_INSET};
            bottom: ${BORDER_INSET};
            z-index: -1;
            border-radius: calc(
                calc(${BORDER_INSET} * -1) +
                    var(--holographic-background__border-radius, 0px)
            );
            background: ${HOLOGRAPHIC_GRADIENT};
        }

        &:after {
            content: '';
            position: absolute;
            top: calc(${BORDER_INSET} + ${BORDER_WIDTH});
            left: calc(${BORDER_INSET} + ${BORDER_WIDTH});
            right: calc(${BORDER_INSET} + ${BORDER_WIDTH});
            bottom: calc(${BORDER_INSET} + ${BORDER_WIDTH});
            z-index: -1;
            border-radius: calc(
                var(--holographic-background__border-radius, 0px) -
                    ${BORDER_INSET} - ${BORDER_WIDTH}
            );
            background-color: white;
            background-blend-mode: soft-light;
            background: ${HOLOGRAPHIC_GRADIENT}, ${RAINBOW_CIRCLES},
                ${WHITE_CORNERS}, ${WHITE_CENTER};
        }
    }

    .glitter-texture {
        mix-blend-mode: overlay;
        opacity: 0.9;

        svg {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
`;
